import { render } from "./Student.vue?vue&type=template&id=5f86bccf"
import script from "./Student.vue?vue&type=script&lang=js"
export * from "./Student.vue?vue&type=script&lang=js"

import "./Student.vue?vue&type=style&index=0&id=5f86bccf&lang=less"

import exportComponent from "/Users/wanglei/lnmp/www/study-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__